import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useI18n } from "@/i18n/I18nContext";
import { AndroidIcon, AppleIcon } from "@/components/apps/Platform";

const COMPAT = ["android", "iphone", "both"];
const CATS = ["app", "minisite"];

const Radios = ({ name, opts, value, onChange, label, icons }) => (
  <div className="flex min-w-0 flex-wrap gap-2" role="radiogroup" aria-label={name}>
    {opts.map((o) => (
      <label key={o} className={`inline-flex max-w-full cursor-pointer items-center gap-1.5 whitespace-normal break-words rounded-full border px-3 py-1.5 text-xs font-semibold ${value === o ? "border-emerald-400 bg-emerald-400/20 text-emerald-100" : "border-white/15 text-neutral-300"}`}>
        <input type="radio" name={name} value={o} required checked={value === o} onChange={() => onChange(o)} className="accent-emerald-400" data-testid={`app-form-${name}-${o}`} />
        {icons && o !== "iphone" && <AndroidIcon />}{icons && o !== "android" && <AppleIcon />} {label(o)}
      </label>
    ))}
  </div>
);

// App form. Developers: category + compatibility are REQUIRED (nothing is decided automatically; not published until filled).
// Official catalogue: automatic; only the iPhone link can be overridden (detected wrapped-site URL by default).
export const PlatformFields = ({ isDev, app, v }) => {
  const { t } = useI18n();
  const detected = !isDev && app?.platform?.detected;
  const needUrl = !isDev || v.compat === "iphone" || v.compat === "both";
  return (
    <fieldset className="min-w-0 space-y-3 rounded-xl border border-emerald-400/25 bg-black/30 p-3" data-testid="app-form-platform">
      {isDev && (
        <>
          <div className="min-w-0 space-y-1.5"><p className="text-sm font-medium text-neutral-200">{t("plat.category")} *</p>
            <Radios name="category" opts={CATS} value={v.category} onChange={v.setCategory} label={(o) => t(`mini.chip.${o}`)} /></div>
          <div className="min-w-0 space-y-1.5"><p className="text-sm font-medium text-neutral-200">{t("plat.field")} *</p>
            <Radios name="compat" opts={COMPAT} value={v.compat} onChange={v.setCompat} label={(o) => t(`plat.opt.${o}`)} icons /></div>
        </>
      )}
      {needUrl && (
        <div className="min-w-0 space-y-1.5">
          <Label htmlFor="app-iphone-url">{t("plat.link")}{isDev ? " *" : ""}</Label>
          <Input id="app-iphone-url" type="url" required={isDev} maxLength={500} value={v.url} placeholder="https://" onChange={(e) => v.setUrl(e.target.value)} data-testid="app-form-iphone-url" />
          <p className="break-words text-[0.7rem] text-neutral-500">{t("plat.linkHint")}</p>
          {detected && v.url !== detected && (
            <p className="flex min-w-0 flex-wrap items-center gap-2 text-xs text-emerald-200" data-testid="app-form-iphone-detected">
              <span className="min-w-0 [overflow-wrap:anywhere]">{t("plat.detected", { url: detected })}</span>
              <button type="button" className="rounded-full border border-emerald-400 px-3 py-1 text-emerald-100" onClick={() => v.setUrl(detected)} data-testid="app-form-iphone-detected-use">{t("plat.useDetected")}</button>
            </p>
          )}
          {!isDev && <p className="break-words text-[0.7rem] text-neutral-500">{t("plat.officialRule")}</p>}
        </div>
      )}
    </fieldset>
  );
};
